import {SheetLocationImpl} from '@mintdata-wsp/common/controllers/spreadsheet/formula/functionAPIs/SheetLocationImpl';
import {SheetRangeImpl} from '@mintdata-wsp/common/controllers/spreadsheet/formula/functionAPIs/SheetRangeImpl';
import {ISheetRange} from '@mintdata/mint-kit/api/functions/SheetAPI';

export const EmptySheetRange:ISheetRange = new SheetRangeImpl(
    '',
    new SheetLocationImpl(
        '',
        -1,
        -1
    ),
    new SheetLocationImpl(
        '',
        -1,
        -1
    )
);
